import { CollectDebugInfoFn } from '@/services/DebugInfoCollector/types';
import { $availableOutgoingBitrate, $incomingBitrate, $outgoingBitrate } from '@/store/debug-info';

export const collectBitrates: CollectDebugInfoFn = () => ({
  incomingBitrate: $incomingBitrate.getState().current,
  outgoingBitrate: $outgoingBitrate.getState().current,
  availableOutgoingBitrate: $availableOutgoingBitrate.getState().current,
});
